<div class="border-div box-height">
  <div class="d-flex filter-header-rt" style="align-items:normal;">

    <h2 class="mainhead mr-auto">
      <span class="text">Offer Comparison</span>
    </h2>
  </div>
  <div *ngIf="!IsPortfolio && !isFromPortfolio" id="container"></div>
  <div *ngIf="!IsPortfolio && isFromPortfolio" style="filter: blur(4px);
  -webkit-filter: blur(4px);"  id="container"></div>
  <div *ngIf="IsPortfolio" class="table-responsive">
    <table class="table basictable row-border hover">
      <thead>
        <tr>
          <th>Property</th>
          <th class="whitespacenowrap">Asking Price</th>
          <th class="whitespacenowrap">Offer Cap Rate</th>
          <th class="whitespacenowrap">Offer Price</th>
          <th class="whitespacenowrap">Discount %</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let offer of offers ;">
          <td><p>{{offer.Property}}</p></td>
          <td><p class="whitespacenowrap">${{offer.AskingPrice | number}}</p></td>
          <td><p>{{(offer.OfferCapRate | number) +'%' }}</p></td>
          <td><p class="whitespacenowrap">${{offer.OfferPrice | number}}</p></td>
          <td><p>{{offer.Contribution +'%'}}</p></td>
        </tr>
      </tbody>
      <tfoot>
        <tr *ngIf="offers?.length == 0 ">
          <td colspan="5" class="odd no-data-available">
            <div class="nodata">
              <i class="fa fa-exclamation-triangle icon"></i>
              <p>No Data Available</p>
            </div>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
